/* Bedtextielonline (Claude): actieblok '2e dekbedovertrek aan halve prijs' op de productpagina (markup in snippets/btol-actie-2e.liquid).
   - kort blok: wat de actie is + knop 'Kies je 2e dekbedovertrek'
   - kijkt naar je winkelwagen: zit er al 1 dekbedovertrek in dat meedoet, dan meldt het dat je met dit erbij er een aan halve prijs krijgt
   - de knop gaat terug naar de lijst waar je vandaan kwam (met je filters en scrollpositie), als dat een lijst met dekbedovertrekken was;
     anders naar alle dekbedovertrekken
   - nog geen dekbedovertrek in je winkelwagen: eerst een korte uitleg (popup), met de keuze om dit dekbedovertrek meteen in je winkelwagen te leggen
   Eén keer per pagina. Na een maatwissel tekent het thema de productinfo opnieuw (nieuw blok, zonder dit script uit te voeren):
   daarom neemt het script altijd het blok dat echt op de pagina staat. */
(function () {
  if (window.__btolA2) { window.__btolA2.later(); return; }
  var tagCache = {};
  var mand = null;

  /* ---------- opmaak van de statusregel en de uitleg-popup ---------- */
  var css = '' +
    '.btol-a2__status{display:flex;align-items:flex-start;gap:10px;margin:12px 0 0;padding:12px 14px;border-radius:14px;background:#fff;font-size:15px;line-height:1.4;color:#2F2A44}' +
    '.btol-a2__status svg{flex:0 0 20px;width:20px;height:20px;color:#3E9B6C;margin-top:1px}' +
    '.btol-a2__status[hidden],.btol-a2__knop[hidden]{display:none!important}' +
    '.btol-a2u{position:fixed;inset:0;z-index:2147483000;display:grid;place-items:center;padding:16px;background:rgba(47,42,68,.45);opacity:0;transition:opacity .2s ease}' +
    '.btol-a2u.is-open{opacity:1}' +
    '.btol-a2u__doos{position:relative;width:min(460px,100%);max-height:calc(100vh - 32px);overflow:auto;padding:24px;border-radius:20px;background:#F6F5F3;color:#2F2A44;box-shadow:0 20px 60px rgba(47,42,68,.3);transform:translateY(8px);transition:transform .2s ease}' +
    '.btol-a2u.is-open .btol-a2u__doos{transform:none}' +
    '.btol-a2u__sluit{position:absolute;top:16px;right:16px;display:grid;place-items:center;width:40px;height:40px;border:0;border-radius:50%;background:#fff;color:#2F2A44;cursor:pointer;transition:background-color .15s ease}' +
    '.btol-a2u__sluit:hover{background:#EEF0FA}' +
    '.btol-a2u__sluit svg{width:14px;height:14px}' +
    '.btol-a2u__stempel{display:grid;place-items:center;align-content:center;width:64px;height:64px;margin:0 0 12px;border-radius:50%;background:#D63B3B;color:#fff;line-height:1}' +
    '.btol-a2u__stempel b{font-size:18px;font-weight:800}.btol-a2u__stempel small{font-size:11px;font-weight:600;margin-top:2px}' +
    '.btol-a2u__titel{margin:0 48px 6px 0;font-size:22px;font-weight:700;line-height:1.25}' +
    '.btol-a2u__intro{margin:0 0 14px;font-size:15px;line-height:1.45;color:rgba(47,42,68,.8)}' +
    '.btol-a2u__stappen{display:grid;gap:10px;margin:0 0 16px;padding:16px;border-radius:16px;background:#fff;list-style:none;counter-reset:s}' +
    '.btol-a2u__stappen li{display:flex;align-items:flex-start;gap:12px;font-size:15px;line-height:1.4;counter-increment:s}' +
    '.btol-a2u__stappen li::before{content:counter(s);flex:0 0 26px;display:grid;place-items:center;width:26px;height:26px;border-radius:50%;background:#2F2A44;color:#fff;font-size:13px;font-weight:700}' +
    '.btol-a2u__knoppen{display:grid;gap:8px}' +
    '.btol-a2u__item{display:grid;grid-template-columns:64px 1fr;gap:12px;align-items:center;margin:0 0 12px;padding:10px;border-radius:16px;background:#fff;border:1.5px solid #2F2A44}' +
    '.btol-a2u__item img{width:64px;height:64px;object-fit:cover;border-radius:10px;display:block;background:#F6F5F3}' +
    '.btol-a2u__item p{margin:0;font-size:12px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:rgba(47,42,68,.6)}' +
    '.btol-a2u__item strong{display:block;font-size:15px;line-height:1.3;color:#2F2A44}' +
    '.btol-a2u__item small{display:block;margin-top:2px;font-size:14px;color:rgba(47,42,68,.75)}' +
    '.btol-a2u__knoppen .button{width:100%;justify-content:center}' +
    '.btol-a2u__tweede{display:flex;align-items:center;justify-content:center;min-height:48px;padding:0 18px;border:0;border-radius:999px;background:#EEF0FA;color:#2F2A44;font:inherit;font-size:17px;font-weight:700;cursor:pointer;transition:background-color .15s ease}' +
    '.btol-a2u__tweede:hover{background:#E1E4F4}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var VINK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function plaats() {
    var alle = Array.prototype.slice.call(document.querySelectorAll('[data-btol-actie2e]'));
    var box = alle[0];
    alle.slice(1).forEach(function (x) { x.remove(); });
    if (!box) return null;
    var prijs = document.querySelector('.product-info [data-block-type="price"]');
    if (prijs && prijs.parentNode && prijs.nextElementSibling !== box) prijs.parentNode.insertBefore(box, prijs.nextSibling);
    return box;
  }

  /* dekbedovertrekken in de winkelwagen die meedoen (geen tag uni of uitverkoop) */
  function haalMand() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var items = (cart.items || []).filter(function (i) { return i.product_type === 'Dekbedovertrek'; });
      return Promise.all(items.map(function (i) {
        if (!tagCache[i.handle]) {
          tagCache[i.handle] = fetch('/products/' + i.handle + '.js').then(function (r) { return r.json(); }).then(function (p) { return p.tags || []; }).catch(function () { return []; });
        }
        return tagCache[i.handle];
      })).then(function (tags) {
        var n = 0;
        items.forEach(function (i, k) {
          var t = (tags[k] || []).map(function (x) { return String(x).toLowerCase(); });
          if (t.indexOf('uni') > -1 || t.indexOf('uitverkoop') > -1) return;
          n += i.quantity;
        });
        return n;
      });
    });
  }

  function teken() {
    var box = plaats();
    if (!box || mand === null) return;
    var status = box.querySelector('[data-btol-a2-status]'), knop = box.querySelector('[data-btol-a2-knop]');
    if (!status) return;
    box.__btolGetekend = true;
    if (mand % 2 === 1) {
      status.innerHTML = VINK + '<span>Je hebt al een dekbedovertrek in je winkelwagen. Met dit erbij krijg je er een aan <strong>halve prijs</strong>.</span>';
      status.hidden = false;
      if (knop) knop.hidden = true;
    } else if (mand > 0) {
      status.innerHTML = VINK + '<span>De korting op de dekbedovertrekken in je winkelwagen staat al in je totaal. Neem er 2 bij en het goedkoopste krijg je weer aan de helft.</span>';
      status.hidden = false;
      if (knop) knop.hidden = false;
    } else {
      status.hidden = true;
      if (knop) knop.hidden = false;
    }
  }

  var bezig = null;
  function vernieuw() {
    bezig = bezig || haalMand().then(function (n) { mand = n; bezig = null; teken(); return n; }).catch(function () { bezig = null; mand = 0; return 0; });
    return bezig;
  }

  /* terug naar de lijst met dekbedovertrekken waar je vandaan kwam (met filters), anders alle dekbedovertrekken */
  function terugUrl(standaard) {
    try {
      var b = JSON.parse(sessionStorage.getItem('btol_laatste_selectie'));
      if (b && b.url && /dekbedovertrek|overtrek/i.test(b.url + ' ' + (b.titel || ''))) {
        sessionStorage.setItem('btol_herstel_scroll', '1');
        return b.url;
      }
    } catch (e) {}
    return standaard || '/collections/dekbedovertrekken';
  }

  /* ---------- uitleg-popup ---------- */
  var pop = null;
  function sluit() {
    if (!pop) return;
    pop.classList.remove('is-open');
    var p = pop;
    setTimeout(function () { p.remove(); }, 200);
    pop = null;
    document.removeEventListener('keydown', esc);
  }
  function esc(e) { if (e.key === 'Escape') sluit(); }
  function huidigeVariant() {
    var bb = document.querySelector('.product-info buy-buttons') || document.querySelector('buy-buttons');
    var form = bb && document.getElementById(bb.getAttribute('form') || '');
    var id = form && form.elements['id'] && form.elements['id'].value;
    var knop = bb && bb.querySelector('button[type="submit"]');
    return id && !(knop && knop.disabled) ? id : null;
  }
  /* wat er in je winkelwagen komt als je op 'Voeg dit toe' klikt: foto, naam, gekozen maat en prijs van deze pagina */
  function ditItem() {
    var info = document.querySelector('.product-info') || document;
    var t = info.querySelector('.product-title');
    var titel = t ? t.textContent.trim() : '';
    var maat = '';
    var r = info.querySelector('variant-picker input[type="radio"]:checked');
    var sets = info.querySelectorAll('variant-picker fieldset');
    for (var i = 0; i < sets.length; i++) {
      var lg = sets[i].querySelector('legend');
      var c = sets[i].querySelector('input[type="radio"]:checked');
      if (lg && c && /maat|afmeting|size/i.test(lg.textContent)) { r = c; break; }
    }
    if (r) { var l = document.querySelector('label[for="' + r.id + '"]'); maat = (l ? l.textContent : r.value).replace(/\s+/g, ' ').trim(); }
    var p = info.querySelector('[data-block-type="price"] sale-price');
    var prijs = p ? p.textContent.replace(/Aanbiedingsprijs|Prijs/gi, '').replace(/\s+/g, ' ').trim() : '';
    var img = document.querySelector('product-gallery img');
    var beeld = img ? (img.currentSrc || img.src) : '';
    return { titel: titel, maat: maat, prijs: prijs, beeld: beeld };
  }
  function tekst(t) { var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; }
  function open(link) {
    if (pop) return;
    var id = huidigeVariant();
    var it = id ? ditItem() : null;
    pop = document.createElement('div');
    pop.className = 'btol-a2u';
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-modal', 'true');
    pop.setAttribute('aria-labelledby', 'btol-a2u-titel');
    pop.innerHTML =
      '<div class="btol-a2u__doos">' +
        '<button type="button" class="btol-a2u__sluit" aria-label="Sluiten"><svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="2"/></svg></button>' +
        '<span class="btol-a2u__stempel" aria-hidden="true"><b>-50%</b><small>op de 2e</small></span>' +
        '<p class="btol-a2u__titel" id="btol-a2u-titel">Zo werkt 2e aan halve prijs</p>' +
        '<p class="btol-a2u__intro">Je hebt nog geen dekbedovertrek in je winkelwagen. Voor de korting heb je er 2 nodig.</p>' +
        '<ol class="btol-a2u__stappen">' +
          '<li>Kies 2 dekbedovertrekken. Ander dessin, maat of merk mag gerust.</li>' +
          '<li>Het goedkoopste van de twee krijg je aan de helft.</li>' +
          '<li>De korting staat meteen in je winkelwagen.</li>' +
        '</ol>' +
        (it && it.titel ? '<div class="btol-a2u__item">' + (it.beeld ? '<img src="' + tekst(it.beeld) + '" alt="">' : '<span></span>') +
          '<div><p>Dit leg je in je winkelwagen</p><strong>' + tekst(it.titel) + '</strong><small>' + tekst([it.maat, it.prijs].filter(Boolean).join(' · ')) + '</small></div></div>' : '') +
        '<div class="btol-a2u__knoppen">' +
          (id ? '<button type="button" class="button" data-btol-a2u-leg>Voeg dit toe en kies je 2e</button>' : '') +
          '<button type="button" class="btol-a2u__tweede" data-btol-a2u-verder>' + (id ? 'Eerst verder kijken' : 'Kies je dekbedovertrekken') + '</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(pop);
    requestAnimationFrame(function () { if (pop) pop.classList.add('is-open'); });
    document.addEventListener('keydown', esc);
    pop.addEventListener('click', function (e) {
      if (e.target === pop || e.target.closest('.btol-a2u__sluit')) { sluit(); return; }
      if (e.target.closest('[data-btol-a2u-verder]')) { location.href = terugUrl(link); return; }
      var leg = e.target.closest('[data-btol-a2u-leg]');
      if (leg) {
        leg.disabled = true;
        leg.textContent = 'Even geduld...';
        fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
          .then(function () { location.href = terugUrl(link); })
          .catch(function () { location.href = terugUrl(link); });
      }
    });
    var eerste = pop.querySelector('[data-btol-a2u-leg], [data-btol-a2u-verder]');
    if (eerste) eerste.focus();
  }

  /* klik op 'Kies je 2e dekbedovertrek' */
  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('[data-btol-a2-knop]');
    if (!knop) return;
    e.preventDefault();
    var link = knop.getAttribute('href');
    var ga = function (n) { if (n > 0) location.href = terugUrl(link); else open(link); };
    if (mand !== null) ga(mand); else vernieuw().then(ga);
  });

  var wacht = null;
  function later() { clearTimeout(wacht); wacht = setTimeout(function () { plaats(); teken(); }, 60); }
  window.__btolA2 = { later: later };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { plaats(); vernieuw(); }); else { plaats(); vernieuw(); }
  document.addEventListener('variant:change', function () { setTimeout(later, 60); setTimeout(later, 450); });
  /* Zonder flitsen: als het thema het blok opnieuw tekent (bij een andere maat of kleur), zetten we het meteen op zijn plaats,
     nog voor de browser het scherm ververst (een MutationObserver loopt vóór het tekenen). */
  if (window.MutationObserver) {
    new MutationObserver(function () {
      var alle = document.querySelectorAll('[data-btol-actie2e]');
      if (!alle.length) return;
      var b = alle[0], prijs = document.querySelector('.product-info [data-block-type="price"]');
      if (alle.length > 1 || (prijs && prijs.nextElementSibling !== b) || (mand !== null && !b.__btolGetekend)) { plaats(); teken(); }
    }).observe(document.body, { childList: true, subtree: true });
  }
  ['cart:change', 'cart:refresh', 'cart:update'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(vernieuw, 150); }); });
})();